module.exports = __webpack_public_path__ + "static/img/tubiao_jinse.c5ec394.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/tubiao_jinse.png
// module id = Ky1K
// module chunks = 2